var map = {
	"./N3Lexer": "./node_modules/n3/lib/N3Lexer.js",
	"./N3Lexer.js": "./node_modules/n3/lib/N3Lexer.js",
	"./N3Parser": "./node_modules/n3/lib/N3Parser.js",
	"./N3Parser.js": "./node_modules/n3/lib/N3Parser.js",
	"./N3Store": "./node_modules/n3/lib/N3Store.js",
	"./N3Store.js": "./node_modules/n3/lib/N3Store.js",
	"./N3StreamParser": "./node_modules/n3/lib/N3StreamParser.js",
	"./N3StreamParser.js": "./node_modules/n3/lib/N3StreamParser.js",
	"./N3StreamWriter": "./node_modules/n3/lib/N3StreamWriter.js",
	"./N3StreamWriter.js": "./node_modules/n3/lib/N3StreamWriter.js",
	"./N3Util": "./node_modules/n3/lib/N3Util.js",
	"./N3Util.js": "./node_modules/n3/lib/N3Util.js",
	"./N3Writer": "./node_modules/n3/lib/N3Writer.js",
	"./N3Writer.js": "./node_modules/n3/lib/N3Writer.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/n3/lib sync recursive ^\\.\\/N3.*$";